/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 14:05:10
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title23 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P23 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          height: 50,
          fontSize: 16,
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#000',
          background: '#fff',
          borderRight: border,
          borderBottom: border,
        },
        colStyle: {
          height: 50,
          fontSize: 16,
          textAlign: 'center',
          fontWeight: index === 0 ? 'bold' : 'normal',
          color: '#000',
          background: '#fff',
          borderRight: border,
          borderBottom: border,
        },
        render: value => {
          if (/DB$/.test(value)) {
            return (
              <div>
                {(value || '').replace('DB', '')}
                <i>DB</i>
              </div>
            )
          }
          return value
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;

    return (
      <Stage>
        <Title23 pageNumber="14">海信VS竞品 | 官方自媒体贡献度对比分析</Title23>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              在监测期内，万达官方自媒体（微信号、微博号、视频号、抖音号）对其世界杯Campaign所贡献数字品牌价值占比最高，为17.48%；海信最低为2.47%，这表明海信对官方自媒体的传播利用略显不足，并且也意味着不能够很好地利用本次世界杯营销从而沉淀为自身的私域用户。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <Chart isShow options={setChart({ title: chartTitle, list: chartList, color: chartColorList })} />
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{
                    boxShadow: 'none',
                    borderTop: 'none',
                    borderLeft: 'none',
                  }}
                />
              </TooltipDrawer>
            </div>
          </div>
          <div contentEditable className={s.explain}>数据说明：本页图表数据观测窗口为2022年11月10日-2022年12月20日，数据源来自覆盖主流媒体、新闻门户、垂直媒体、地方网站、今日头条、一点资讯、微博、知乎、微信等平台自媒体号的全网信息。</div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P23);



// WEBPACK FOOTER //
// src/routes/visualChart/P23/index.js